module.exports = __webpack_public_path__ + "static/itat-9127e4c286407e0813d0f8e0c1b064ec.jpg";